export const gtw = {
  btn: "px-2 py-1 rounded shadow border focus:outline-none  text-xs font-bold",
  activeBtn: "text-white bg-cm-blue border-cm-blue shadow-lg",
  input: "px-2 py-1 focus:outline-none border rounded",
};
